import { AmbientLight, BoxGeometry, Camera, Color, DirectionalLight, Mesh, MeshBasicMaterial, Object3D, PerspectiveCamera, PointLight, Scene, Vector2, Vector3, WebGLRenderer } from 'three';
import {
  createWorld,
  Types,
  defineComponent,
  defineQuery,
  addEntity,
  addComponent,
  pipe,
  IWorld,
} from 'bitecs'
import { MainSystem, createMainSystem } from './systems/mainSystem';
import { setObject3dComponent } from './systems/bit-object-system';
import { Cube, RPMAvatar } from './utils/components';
import { prepareSystems } from './prepareSystems';
import { MediaPipePredictor } from './mediaPipePredictor';

declare global {
  interface Window { APP?: APP }
  interface Object3D {
    eid: number;
  }
}

export interface BitObject3D extends Object3D{
  eid?: number;
}


export interface World extends IWorld{
  time: {
    delta: number, elapsed: number, then: number
  }
  mainSystem: MainSystem,
  eid2obj: Map<number, BitObject3D>,
  scene: Scene,
}

export interface APP{
  scene: Scene
  renderer: WebGLRenderer
  camera: Camera
  world: World,
  mediaPipePredictor?: MediaPipePredictor,
}

export function initSceneAndAnimate(canvas: HTMLCanvasElement) : APP{
  const scene = new Scene()
  // const light = new DirectionalLight( 0xFFFFFF );
  // scene.add(light)
  const shadowMapSize = new Vector2(2048, 2048)
  let lights = [];
  const ambient = new AmbientLight(undefined, 0.7) ;
  lights.push( ambient )
  const pl1 = new PointLight(new Color(1,1,0), 0.5);
  pl1.castShadow = true;
  pl1.position.set(0.5, 1.75, 1)
  pl1.intensity = 0.7;
  pl1.shadow.mapSize.copy(shadowMapSize)
  lights.push( pl1)

  const pl2 = new PointLight(new Color(1,0,0), 0.5);
  pl2.castShadow = true;
  pl2.position.set(0.2, 1, 1)
  pl2.intensity = 1;
  pl2.shadow.mapSize.copy(shadowMapSize)
  lights.push( pl2)

  const pl3 = new PointLight(undefined, 0.5);
  pl3.castShadow = true;
  pl3.position.set(0, 1.5, 0.7)
  pl3.intensity = 0.5;
  pl3.shadow.mapSize.set(1024,1024)
  lights.push( pl3)

  lights.forEach(l => scene.add(l))
  // <pointLight position={[10, 10, 10]} color={new Color(1, 1, 0)} intensity={0.5} castShadow />
  //       <pointLight position={[-10, 0, 10]} color={new Color(1, 0, 0)} intensity={0.5} castShadow />
  //       <pointLight position={[0, 0, 10]} intensity={0.5} castShadow />
  // scene.matrixAutoUpdate = false;
  // scene.matrixWorldAutoUpdate = false;
  const camera = new PerspectiveCamera(25, window.innerWidth / window.innerHeight, 0.1, 1000);
  // const renderer = new WebGLRenderer({canvas});
  const renderer = new WebGLRenderer({canvas, alpha: true, antialias: true});
  renderer.setClearColor( 0x000000, 0 );
  renderer.setSize(window.innerWidth, window.innerHeight);
  renderer.shadowMap.enabled = true;

  // camera.position.z = 5;
  // camera.position.set(0,1.7,0.5)
  // camera.position.set(0, 1.9, 1.2)
  camera.position.set(0, 1.9, 1.2)
  camera.lookAt(0,1.65,0)

  const world : World = createWorld();
  world.eid2obj = new Map();
  world.time = { delta: 0, elapsed: 0, then: performance.now() }
  world.mainSystem = createMainSystem(world);
  world.mainSystem.addSystem((world: World) => {
    renderer.render(scene, camera);
  }, "render")
  world.mainSystem.play(world);
  world.mainSystem.setMaxFps(60);
  world.scene = scene;


  const eid = addEntity(world);
  addComponent(world, RPMAvatar, eid);
  prepareSystems(world);
  
  window.APP = {
    scene,
    renderer,
    camera,
    world,
  }
  return window.APP;
}